import React from "react";
import { GeneralSettingsPage } from "@rankmi/ats-app";

const NewSettings = ({ organizationId, organizationSlug, organizationRequestTypes }) => {
  return (
    <GeneralSettingsPage
      organizationId={organizationId}
      organizationSlug={organizationSlug}
      organizationRequestTypes={organizationRequestTypes || []}
    />
  );
};
export default NewSettings;
